import { all, call } from 'redux-saga/effects';

import watchGames from './games';

export function* lobbySaga() {
  yield all([call(watchGames)]);
}
